import './utils/installTimestampedConsole';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import { Provider } from 'react-redux';
import './index.css';
import './mobile-layout.css';
import './i18n'; // initialize i18n before rendering
import App from './App.tsx';
import { store } from './store';
import { hydrateAuth } from './store/auth/authSlice';
import { NotificationProvider } from './components/ui/NotificationProvider';
import { DeleteConfirmationProvider } from './components/ui/DeleteConfirmationProvider';

// Hydrate auth on startup to preserve prior session and initialize chat runtime
store.dispatch(hydrateAuth());

// Keep Redux auth state in sync when other parts of the app write credentials into localStorage
if (typeof window !== 'undefined') {
  try {
    window.addEventListener('auth:login', () => {
      try { store.dispatch(hydrateAuth()); } catch {}
    });
  } catch {}
}

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Provider store={store}>
      <NotificationProvider>
        <DeleteConfirmationProvider>
          <App />
        </DeleteConfirmationProvider>
      </NotificationProvider>
    </Provider>
  </StrictMode>,
);
